<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:absolute,top:0,bottom:0,overflow:disShow?'hidden':'auto'}">
                    <div class="q_title">响应详情</div>
                    <div class="mainSty mblk">
                        <div v-for="(item,index) in itemList" :key="index" class="mblk">
                            <detailList :item="item"></detailList>
                        </div>
                    </div>
                    <div class="q_title">支持信息</div>
                    <div class="mainSty mblk">
                        <div v-for="(item,index) in itemList2" :key="index" class="mblk">
                            <detailList :item="item"></detailList>
                        </div>
                    </div>
                    <div class="q_title">故障信息</div>
                    <div class="mainSty mblk">
                        <div v-for="(item,index) in itemList3" :key="index" class="mblk">
                            <detailList :item="item"></detailList>
                        </div>
                    </div>

                    <div class="q_title">审批信息</div>
                    <div class="mainSty mblk">
                        <div v-for="(item, index) in itemList4" :key="index">
                            <!-- 审批图片处理 -->
                            <template v-if="item.tit === '审批图片：'">
                                <div class="ffntblkt">
                                    <div style="display:flex;width:100%;height:100%">
                                        <div class="ffnttxt1">{{ item.tit }}</div>
                                        <div class="ffnttxt2" style="flex:1; text-align:right;">
                                            <div v-if="item.subtit" class="img-wrapper">
                                                <img 
                                                    :src="getImageUrl(item)" 
                                                    class="approval-img"
                                                    @click="handleImageClick(item)"
                                                    @error="handleImageError($event, item)"
                                                    alt="审批图片"
                                                >
                                            </div>
                                            <span v-else>无图片</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <detailList :item="item"></detailList>
                            </template>
                        </div>
                    </div>

                    <div class="nblk" style="display:flex">
                        <div class="lblk">
                            <van-button plain type="info" block class="bblk" @click="toIndex">返回</van-button>
                        </div>
                    </div>
                    
                    <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
                    <van-dialog v-model:show="disShow" @cancel="reback" @confirm="submit1" confirm-button-color="#108EE9" show-cancel-button>
                        <div class="digtxt3">
                            <img src="../../components/image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                            <div style="padding: 20px 0;">确认关闭响应支持</div>
                        </div>
                    </van-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
import detailList from "@/components/detailList";
import customToast from "@/components/toast.vue";
export default {
    components: { detailList ,customToast},
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            disShow: false,
            itemList4: [
				{
					tit: "审批人:",
					subtit: "",
				},
				{
					tit: "审批状态：",
					subtit: "",
				},
				{
					tit: "审批内容：",
					subtit: "",
				},
				{
					tit: "审批图片：",
					subtit: "",
				}
			],
            itemList: [
                {
                    tit: "响应编号",
                    subtit: "",
                },
                {
                    tit: "用户姓名：",
                    subtit: "",
                },
                {
                    tit: "联系电话：",
                    subtit: "",
                },
                {
                    tit: "用户单位",
                    subtit: "",
                },
                {
                    tit: "部门（办公室）：",
                    subtit: "",
                },
                {
                    tit: "提交时间：",
                    subtit: "",
                },
                {
                    tit: "所属分类：",
                    subtit: "",
                },
            ],
            itemList3: [
                {
                    tit: "故障类型：",
                    subtit: "",
                },
                {
                    tit: "事件级别：",
                    subtit: "",
                },
                {
                    tit: "故障描述：",
                    subtit: "",
                },
            ],
            itemList2: [
                {
                    tit: "工程师：",
                    subtit: "",
                },
                {
                    tit: "联系电话：",
                    subtit: "",
                },
                {
                    tit: "公司：",
                    subtit: "",
                },
                {
                    tit: "完成时间：",
                    subtit: "",
                },
                {
                    tit: "组别：",
                    subtit: "",
                },
            ],
            failItem: [],
        };
    },
    created() {
        this.getData();
        this.getlevelData();
    },
    methods: {
        // 图片相关方法
       
       // 获取图片地址（统一处理主备地址）
		getImageUrl(item) {
			// 先尝试主地址
			return `http://180.100.77.186:9085/prod-yh${item.subtit}`;
		},
		
		// 图片点击预览
		handleImageClick(item) {
			// 防止事件冒泡到父元素
			event.stopPropagation();
			
			// 检查当前使用的是哪个地址
			const url = `http://180.100.77.186:9085/prod-yh${item.subtit}`;
			
			ImagePreview([url]);
		},
		
		// 图片加载错误处理
		handleImageError(e, item) {
			// 尝试备用地址
			const backupUrl = `http://180.100.77.186:9085/prod-yh${item.subtit}`;
			e.target.src = backupUrl;
			// 记录当前使用的是备用地址
			item.currentUrl = backupUrl;
			
			// 备用地址也失败的情况
			e.target.onerror = () => {
				e.target.src = '';
				e.target.alt = '图片加载失败';
				Toast('图片加载失败');
			};
		},
        
        reback() {
            this.disShow = false;
        },
        submit1() {
            this.disabled1 = true;
            let data = {
                recordId: this.$route.query.recordId,
            };
            this.$api
                .get("/app/support/deleteSupport", { params: data })
                .then((res) => {
                    this.disabled1 = false;
                    if (res.data.code == "0000") {
                        this.disShow = false;
                        this.toastRow = {
                            selId: 3,
                            title: "成功关闭",
                            text: "您已成功关闭响应支持",
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                        if (this.$route.query.froms == 1) {
                            setTimeout(() => {
                                this.$router.push("/responseDetail");
                            }, 1000);
                        } else {
                            setTimeout(() => {
                                this.$router.push({ path: "/index" });
                            }, 1000);
                        }
                    }
                });
        },
        close() {
            this.disShow = true;
        },
        getlevelData() {
            let data = { dictType: 1 };
            this.$api
                .get("/appConfigDictData/selectConfig", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.failItem = res.data.data;
                    } else if (res.data.code == "9999") {
                        this.toastRow = {
                            selId: 4,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        toIndex() {
            if (this.$route.query.froms == 1) {
                this.$router.push("/responseDetail");
            } else {
                this.$router.push("/index");
            }
        },
        getData() {
            let data = { recordId: this.$route.query.recordId };
            this.$api
                .get("/app/support/getSupportRecordDetailInfo", {
                    params: data,
                })
                .then((res) => {
                    if (res.data.code == "0000") {
                        let data = res.data.data;
                        let datan = data.assessTime
                            ? this.dayjs(data.assessTime).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                            : "";
                        if (data.assessStatus == 0) {
                            data.assessStatus = "不满意";
                        } else if (data.assessStatus == 1) {
                            data.assessStatus = "满意";
                        }
                        data.responseType =
                            data.responseType == 1 ? "硬件报修" : "软件报修";
                        let length = data.recordId.toString().length;
                        if (length == 1) {
                            data.recordId = `HGSL-00000${data.recordId}(Q)`;
                        } else if (length == 2) {
                            data.recordId = `HGSL-0000${data.recordId}(Q)`;
                        } else if (length == 3) {
                            data.recordId = `HGSL-000${data.recordId}(Q)`;
                        } else if (length == 4) {
                            data.recordId = `HGSL-00${data.recordId}(Q)`;
                        } else if (length == 5) {
                            data.recordId = `HGSL-0${data.recordId}(Q)`;
                        } else if (length == 6) {
                            data.recordId = `HGSL-${data.recordId}(Q)`;
                        } else if (length > 6) {
                            data.recordId = `HGSL-${data.recordId}(Q)`;
                        }
                        this.itemList = [
                            {
                                tit: "响应编号",
                                subtit: data.recordId,
                            },
                            {
                                tit: "用户姓名：",
                                subtit: data.maintenanceName,
                            },
                            {
                                tit: "联系电话：",
                                subtit: data.maintenanceTel,
                            },
                            {
                                tit: "用户单位",
                                subtit: data.maintenanceCompanyName,
                            },
                            {
                                tit: "部门（办公室）：",
                                subtit: data.maintenanceOffice,
                            },
                            {
                                tit: "提交时间：",
                                subtit: data.maintenanceTime,
                            },
                            {
                                tit: "所属分类：",
                                subtit: "快速报修",
                            },
                        ];
                        if (data.group == 0) {
                            data.group = "机动组";
                        } else if (data.group == 1) {
                            data.group = "驻场组";
                        } else {
                            data.group = "";
                        }
                        let datay = data.engineerFinishTime
                            ? this.dayjs(data.engineerFinishTime).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                            : "";
                        this.itemList2 = [
                            {
                                tit: "工程师：",
                                subtit: data.engineerName,
                            },
                            {
                                tit: "联系电话：",
                                subtit: data.engineerTel,
                            },
                            {
                                tit: "公司：",
                                subtit: data.engineerCompanyName,
                            },
                            {
                                tit: "组别：",
                                subtit: data.group,
                            },
                            {
                                tit: "最迟解决时间：",
                                subtit: data.lastFinishTime,
                            },
                            {
                                tit: "实际完成时间：",
                                subtit: data.engineerFinishTime,
                            },
                        ];
                        if (data.supportLevel == 0) {
                            data.supportLevel = "低";
                        } else if (data.supportLevel == 1) {
                            data.supportLevel = "中";
                        } else if (data.supportLevel == 2) {
                            data.supportLevel = "高";
                        } else if (data.supportLevel == 3) {
                            data.supportLevel = "紧急";
                        }
                        this.itemList4 = [
							{
								tit: "审批人：",
								subtit: data.checkUser,
							},
							{
								tit: "审批状态：",
								subtit:
									data.checkStatus == "0"
										? "待审批":data.checkStatus == "1"
										?"通过": "未通过",
							},
							{
								tit: "审批内容：",
								subtit: data.checkContent,
							},
							{
								tit: "审批图片：",
								subtit: data.checkImg,
							},
						];
                        this.itemList3 = [
                            {
                                tit: "故障类型：",
                                subtit: data.supportTypeName,
                            },
                            {
                                tit: "事件级别：",
                                subtit: data.supportLevel,
                            },
                            {
                                tit: "故障描述：",
                                subtit: data.supportDescribe,
                            },
                        ];
                    } else {
                        this.datas = [];
                    }
                });
        },
    },
};
</script>

<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
::v-deep .van-field__value {
    overflow: auto;
}
::v-deep .van-field {
    max-height: 200px;
    height: auto !important;
}
.digtxt3 {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.dialogs1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 189px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 28px;
    margin: 24px auto;
    margin-bottom: 54px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    margin-left: 20px;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 100%;
}
.mainSty {
    width: 303px;
    height: 300x;
    padding: 14px 21px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
}
.q_title {
    width: 345px;
    height: 20px;
    margin: 15px auto;
    font-size: 16px;
    font-weight: 700;
    color: #222222;
}
.mblk {
    margin-top: 20px;
}
.nblk {
    width: 100%;
    height: 44px;
}
.lblk {
    flex: 0 0 281px;
    height: 44px;
    margin: 20px auto;
}
.bblk {
    border-radius: 22px;
}
/* 审批图片样式 */
.approval-img {
  width: auto;
  height: auto;
  max-width: 200px; /* 最大宽度限制 */
  max-height: 150px; /* 最大高度限制 */
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s;
}

/* 悬停效果 */
.approval-img:hover {
  transform: scale(1.05);
}

/* 图片容器 */
.img-container {
  display: inline-block;
}
.digtxt1 {
	width: 200px;
	height: 28px;
	margin: 24px auto;
	margin-bottom: 54px;
	font-size: 20px;
	font-weight: 400;
	text-align: center;
	color: #003cff;
	line-height: 33px;
}
.fftnEllipses {
	width: 100%;
	padding: 9px 0;
	box-sizing: border-box;
}

.fftnEllipse {
	width: 100%;
	height: 100%;
	background: #ffffff;
	border: 1px solid #cccccc;
	border-radius: 8px;
	font-size: 10px;
	font-weight: 400;
	text-align: left;
	color: #666666;
	line-height: 18px;
	padding: 9px;
	box-sizing: border-box;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: wrap;
}

.ffntblkt {
	position: relative;
	margin: 0 auto;
	padding: 10px 13px 10px 0;
	background: #fff;
	border-bottom: 1px solid #cccccc
}

.ffnttxt1 {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: wrap;
	flex: 0 0 100px;
	text-align: left;
	font-size: 12px;
	font-weight: 400;
	color: #666;
}

.ffnttxt2 {
	word-break: break-all;
	flex: 1;
	text-align: right;
	font-size: 13px;
	font-weight: 400;
	color: #333333;
}

.ffnttxt2sh {
	color: #8E94A1;
}
</style>